
























import { Component, Vue, Prop } from 'vue-property-decorator';
import { CNodeReply } from '@/interface';
import BaseMarkDown from './BaseMarkDown.vue';
import { Log } from '@/utils';

@Component({
  components: {
    BaseMarkDown,
  },
})
export default class BaseReply extends Vue {
  @Prop({required: true})
  private data!: CNodeReply;
}
